import { render, staticRenderFns } from "./VisualizarFNRH.vue?vue&type=template&id=1a24b170&scoped=true&"
import script from "./VisualizarFNRH.vue?vue&type=script&lang=js&"
export * from "./VisualizarFNRH.vue?vue&type=script&lang=js&"
import style0 from "./VisualizarFNRH.vue?vue&type=style&index=0&id=1a24b170&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a24b170",
  null
  
)

export default component.exports